import React from "react";

import {
    Alert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    Modal,
} from "reactstrap";
import WarehouseDataService from "../../services/WarehouseDataService";

class WarehouseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultModal: false,
            currentWarehouse: {},
        };
        this.warehouseDataService = new WarehouseDataService();
    }

    handleInputChanged(e) {
        let nam = e.target.name
        let val = e.target.value
        let updateState = true;

        if (updateState) {
            this.setState(prevState => {
                let currentWarehouse = Object.assign({}, prevState.currentWarehouse);
                currentWarehouse[nam] = val;
                return { currentWarehouse };
            })
        }
    }

    setErrormessage(errorMessage, checkoutDisabled) {
        this.setState({
            errorMessage: errorMessage,
            checkoutDisabled: checkoutDisabled,
        })
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
    }

    handleResponse(data, successMessage) {
        if (data?.data?.errorMessage) {
            this.setState({ errorMessage: data.data.errorMessage })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentWarehouse: {} })
            this.props.fetchData()
        }
        setTimeout(() => {
            this.setState({ successMessage: undefined, errorMessage: undefined });
        }, 5000);
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (this.props.formType === 'edit') {
                this.handleEditWarehouse();
            } else {
                this.handleAddWarehouse();
            }
        }
    }

    handleAddWarehouse() {
        let currentWarehouse = this.state.currentWarehouse;

        this.warehouseDataService.add(currentWarehouse.warehouse_name)
            .then((data) => {
                this.handleResponse(data, "Warehouse berhasil ditambahkan");
            })
    }

    handleEditWarehouse() {
        let currentWarehouse = this.state.currentWarehouse;

        this.warehouseDataService.update(currentWarehouse)
            .then((data) => {
                this.handleResponse(data, "Warehouse berhasil diubah");
            })
    }

    onModalOpened() {
        this.setCurrentWarehouse();
    }

    onModalClosed() {
        this.setState({
            currentWarehouse: {},
            errorMessages: [],
        })
    }

    setCurrentWarehouse() {
        if (this.props.formType === 'edit') {
            this.setState({ currentWarehouse: this.props.currentWarehouse })
            this.setState(prevState => {
                let currentWarehouse = Object.assign({}, prevState.currentWarehouse)
                return { currentWarehouse };
            })
        }
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h3 className="mb-0">{this.props.formType === 'add' ? 'Tambah warehouse baru' : 'Ubah warehouse'}</h3>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                                <Alert color="danger">
                                    {errorMessage}
                                </Alert>
                            ))}
                            {this.state.errorMessage && (
                                <Alert color="danger">
                                    {this.state.errorMessage}
                                </Alert>
                            )}
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                    htmlFor="input-name"
                                >
                                    Nama Warehouse
                                </label>
                                <Input placeholder="Nama warehouse"
                                    className="form-control-alternative"
                                    name="warehouse_name"
                                    id="input-name"
                                    value={this.state.currentWarehouse?.warehouse_name}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                            </FormGroup>
                            <FormGroup>
                                <div className="btn-wrapper text-right">
                                    <Button
                                        className="my-4"
                                        color="secondary"
                                        type="button"
                                        onClick={this.props.toggleModal}
                                    >
                                        Batal
                                    </Button>
                                    <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                        onClick={() => this.props.formType === 'add' ? this.handleAddWarehouse() : this.handleEditWarehouse()}
                                    >
                                        Simpan
                                    </Button>
                                </div>
                            </FormGroup>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default WarehouseModal;
